import ApiClient from '@/api/ApiClient';
import BaseService from './BaseService';
import Instructor from '@/api/models/Instructor';
class InstructorService extends BaseService {
    #prefixUrl = 'api/instructor/';

    STORAGE_DEFINITION = {
        DEFAULT_INSTRUCTOR: 'defaultInstructor'
    };

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Get default instructor
     * @returns {Instructor|null}
     */
    async getDefault() {
        const response = await this.api.executeRequest(`/`, {}, this.api.methods.GET);

        let instructor = null;

        if (response.success() && response.getContent() != null) {
            instructor = new Instructor(response.getContent());
        }
        
        return instructor;
    }

    /**
     * Get default instructor and saves on Storage
     * @returns {Intructor|null}
     */
    async getDefaultInstructor() {
        let instructor = this.getStorage().get(this.STORAGE_DEFINITION.DEFAULT_INSTRUCTOR);

        if (!instructor) {
            instructor = await this.getDefault();
            this.getStorage().save(this.STORAGE_DEFINITION.DEFAULT_INSTRUCTOR, instructor);
        }

        return instructor;
    }

    /**
     * Saves instructor by creating or updating
     * @param {object} instructorData
     * @returns {api/models/Response}
     */
    async save(instructorData = {}) {
        const response = await this.api.executeRequest('/', instructorData, this.api.methods.POST);
        
        return response;
    }
}

export default new InstructorService();
